
/**
 * @export
 * @enum {string}
 */
export enum CrmType {
    SFCRM = 'SFCRM',
    MDCRM = 'MDCRM',
    DEALCLOUDCRM = 'DEALCLOUDCRM',
    HUBSPOTCRM = 'HUBSPOTCRM',
    PITCHBOOK = 'PITCHBOOK'
}